import './Avatar.css';
import Fade from 'react-reveal';

const Avatar = ({ p }) => {
    const { name, id, tags, img, description, liveSite, gitHub, frondEnd, backEnd } = p;
    return (
        <Fade bottom duration={2500} distance="40px">
            <div className='col mb-4'>
                <div id='coll' className='card h-100 shadow rouded'>
                    <div className='card-body  pb-5'>
                        <div className="con">
                            <div style={{
                                width: '383px',
                                height: '300px',
                                backgroundImage: `url(${img})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'top',
                                transition: 'ease-in-out 2s',
                            }} className="box"></div>
                        </div>
                        <h3 id='titlees' className='fw-bold pt-5 '>{name}</h3>
                        <p className='des'>{description}</p>
                        {
                            tags.map(tag => <button className='btn3 mt-2 ms-3'>{tag}</button>)
                        }

                    </div>
                    <div className='d-flex justify-content-start ps-3 pb-3'>
                        <a href={liveSite} target="_blank" className='btn btnn text-white fw-bold'><i class="fas fa-external-link me-2"></i>Live</a>
                        {
                            gitHub && <a href={gitHub} target="_blank" className='btn btnn ms-5 text-white fw-bold'><i class="fab fa-github me-2"></i>GitHub</a>

                        }
                        {
                            frondEnd && <a href={frondEnd} target="_blank" className='btn btnn ms-5 text-white fw-bold'><i class="fab fa-github me-2"></i>Front-End Link</a>

                        }
                        {
                            backEnd && <a href={backEnd} target="_blank" className='btn btnn ms-5 text-white fw-bold'><i class="fab fa-github me-2"></i>Back-End Link</a>

                        }
                    </div>
                </div>
            </div >
        </Fade>
    );
};

export default Avatar;